"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

exports.__esModule = true;

var em_1 = __importDefault(require("polished/lib/helpers/em"));

var prop_types_1 = __importDefault(require("prop-types"));

var react_1 = __importStar(require("react"));

var sportnet_utilities_1 = require("sportnet-utilities");

var styled_components_1 = __importDefault(require("styled-components"));

var Header_1 = __importDefault(require("../../components/Header"));

var Table = styled_components_1["default"].table(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  border-collapse: collapse;\n  width: 100%;\n"], ["\n  border-collapse: collapse;\n  width: 100%;\n"])));
var Td = styled_components_1["default"].td(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  background: #fff;\n  padding: ", " ", ";\n  text-align: left;\n  font-size: ", ";\n  border: ", " solid #eceeef;\n  color: #444f51;\n"], ["\n  background: #fff;\n  padding: ", " ", ";\n  text-align: left;\n  font-size: ", ";\n  border: ", " solid #eceeef;\n  color: #444f51;\n"])), em_1["default"](10), em_1["default"](15), em_1["default"](13), em_1["default"](1));
var Th = styled_components_1["default"].th(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  padding: ", " ", ";\n  text-align: left;\n  font-size: ", ";\n  color: #fff;\n  border: ", " solid #eceeef;\n  background: #989898;\n"], ["\n  padding: ", " ", ";\n  text-align: left;\n  font-size: ", ";\n  color: #fff;\n  border: ", " solid #eceeef;\n  background: #989898;\n"])), em_1["default"](10), em_1["default"](15), em_1["default"](12), em_1["default"](1));
var TableWrapper = styled_components_1["default"].div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  overflow-x: auto;\n"], ["\n  overflow-x: auto;\n"])));

var WidgetTable =
/** @class */
function (_super) {
  __extends(WidgetTable, _super);

  function WidgetTable(props) {
    var _this = _super.call(this, props) || this;

    _this.renderCol = _this.renderCol.bind(_this);
    return _this;
  }

  WidgetTable.prototype.renderCol = function (col, index, rowLength) {
    var header = sportnet_utilities_1.getProp(this.props, ['data', 'header'], []);

    if (header.includes('l') && index === 0) {
      return react_1["default"].createElement(Th, {
        key: col + "-" + index,
        dangerouslySetInnerHTML: {
          __html: col
        }
      });
    } else if (header.includes('r') && index === rowLength - 1) {
      return react_1["default"].createElement(Th, {
        key: col + "-" + index,
        dangerouslySetInnerHTML: {
          __html: col
        }
      });
    }

    if (col.includes('@')) {
      return react_1["default"].createElement(Td, {
        key: col + "-" + index
      }, react_1["default"].createElement("a", {
        href: "mailto: " + col,
        dangerouslySetInnerHTML: {
          __html: col
        }
      }));
    }

    if (col.match(/((?:\+|00)[17](?: |-)?|(?:\+|00)[1-9]\d{0,2}(?: |-)?|(?:\+|00)1-\d{3}(?: |-)?)?(0\d|\([0-9]{3}\)|[1-9]{0,3})(?:((?: |-)[0-9]{2}){4}|((?:[0-9]{2}){4})|((?: |-)[0-9]{3}(?: |-)[0-9]{4})|([0-9]{7}))/g)) {
      return react_1["default"].createElement(Td, {
        key: col + "-" + index
      }, react_1["default"].createElement("a", {
        href: "tel: " + col,
        dangerouslySetInnerHTML: {
          __html: col
        }
      }));
    }

    return react_1["default"].createElement(Td, {
      key: col + "-" + index,
      dangerouslySetInnerHTML: {
        __html: col
      }
    });
  };

  WidgetTable.prototype.render = function () {
    var _this = this;

    var _a = this.props.data,
        table = _a.table,
        title = _a.title;
    var header = sportnet_utilities_1.getProp(this.props, ['data', 'header'], []);
    return react_1["default"].createElement("div", null, title && react_1["default"].createElement(Header_1["default"], null, title), react_1["default"].createElement(TableWrapper, null, react_1["default"].createElement(Table, null, header.includes('t') && react_1["default"].createElement("thead", null, react_1["default"].createElement("tr", null, table[0].map(function (col, idx) {
      return react_1["default"].createElement(Th, {
        key: col + "-" + idx.toString(),
        dangerouslySetInnerHTML: {
          __html: col
        }
      });
    }))), header.includes('b') && react_1["default"].createElement("tfoot", null, react_1["default"].createElement("tr", null, table[table.length - 1].map(function (col, idx) {
      return react_1["default"].createElement(Th, {
        key: col + "-" + idx.toString(),
        dangerouslySetInnerHTML: {
          __html: col
        }
      });
    }))), react_1["default"].createElement("tbody", null, table.map(function (row, index) {
      if (index === 0 && header.includes('t')) {
        return null;
      }

      if (index === table.length - 1 && header.includes('b')) {
        return null;
      }

      return react_1["default"].createElement("tr", {
        key: row + "-" + index.toString()
      }, table[index].map(function (col, colIndex) {
        return _this.renderCol(col, colIndex, table[index].length);
      }));
    })))));
  };

  return WidgetTable;
}(react_1.PureComponent);

WidgetTable.propTypes = {
  data: prop_types_1["default"].shape({
    header: prop_types_1["default"].arrayOf(prop_types_1["default"].string),
    title: prop_types_1["default"].string,
    table: prop_types_1["default"].arrayOf(prop_types_1["default"].arrayOf(prop_types_1["default"].string)).isRequired
  }).isRequired
};
exports["default"] = WidgetTable;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;